import PropTypes from 'prop-types';

var propTypes = {
    src: PropTypes.string.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
    onUrlDataChange: PropTypes.func,
    debounceInterval: PropTypes.number,
    showZoomControl: PropTypes.bool,
    className: PropTypes.string,
};
var zoomControlPropTypes = {
    onChange: PropTypes.func,
    minZoom: PropTypes.number.isRequired,
    maxZoom: PropTypes.number.isRequired,
    zoom: PropTypes.number.isRequired,
};
var defaultProps = {
    showZoomControl: true,
    debounceInterval: 1000,
};
var zoomControlDefaultProps = {
    minZoom: 0,
    maxZoom: 10,
    zoom: 0,
};

export { defaultProps, propTypes, zoomControlDefaultProps, zoomControlPropTypes };
